/**
 * Wer bekommt die Morse-Lernseite? (06.10.2026, Morse-Modul Bahn 1)
 *
 * EIN Besitzer für die Regel, die Menü, Einstellungen und Server gleich
 * rechnen müssen (Muster shared/warte-satz.ts):
 *
 *   - nur Konto 1 (Martin: „zuerst nur Konto 1“; später Freigabe wie die
 *     anderen Module im Admin);
 *   - dort an, solange `morseLernen` nicht ausdrücklich `false` ist — Martin
 *     hat die Seite selbst bestellt, er soll sie nicht erst suchen müssen.
 *
 * ⚠️ Der Schalter blendet nur den Menüpunkt aus. Der Server prüft das Konto,
 *    nicht den Schalter: wer die Seite ausblendet, verliert nichts — der
 *    Fortschritt bleibt am Konto und ist beim Wiedereinschalten da.
 */

/** Der Schlüssel in den Einstellungen des Kontos. */
export const MORSE_FELD = "morseLernen";

/** Nur dieses Konto bekommt die Seite (Betreiber, SUPERUSER_ID in server/werkzeug-bereiche.ts). */
export const MORSE_KONTO = 1;

/** Gibt es die Seite für dieses Konto überhaupt (und steht der Schalter in den Einstellungen)? Rein. */
export function morseFuerKonto(userId: number | null | undefined): boolean {
  return userId === MORSE_KONTO;
}

/** Steht die Seite im Menü? Nur Konto 1; dort an, solange `morseLernen` nicht ausdrücklich `false` ist. Rein. */
export function morseAn(wert: unknown, userId: number | null | undefined): boolean {
  return morseFuerKonto(userId) && wert !== false;
}

/** Die Wege des Servers (server/morse-routen.ts) — eine Quelle für Seite und Server. */
export const MORSE_PFADE = {
  stand: "/api/morse/stand",
  sitzung: "/api/morse/sitzung",
  einstellungen: "/api/morse/einstellungen",
  /** Die Übungsstufe selbst setzen („Eine Stufe zurück“, „Stufe wählen“) — 08.10.2026. */
  stufe: "/api/morse/stufe",
} as const;
